export default {
  singleUseToken: null,
  loadingSingleUseToken: false,
  loadingSingleUseTokenSuccess: false,
  loadingSingleUseTokenFailed: false,
  loadingSingleUseTokenError: null,
};



// WEBPACK FOOTER //
// ./src/store/modules/tokens/state.js